import { render, staticRenderFns } from "./AffiliateEditCpa.vue?vue&type=template&id=39867b78&scoped=true&"
import script from "./AffiliateEditCpa.vue?vue&type=script&lang=js&"
export * from "./AffiliateEditCpa.vue?vue&type=script&lang=js&"
import style0 from "./AffiliateEditCpa.vue?vue&type=style&index=0&id=39867b78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39867b78",
  null
  
)

export default component.exports